import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { getAuthRoute, AUTH_ROUTES } from '~/lib/auth/routes'
import { createSessionQuery } from '~/lib/session-query'
import { AiAssistantPage } from '~/features/ai-assistant/components/ai-assistant-page'
import { seo } from '~/utils/seo'
import { getPageMeta } from '~/utils/seo-meta'

const searchSchema = z.object({
  context: z.string().optional(),
  shopId: z.coerce.number().optional()
})

export const Route = createFileRoute('/{-$locale}/ai-assistant')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(
      createSessionQuery(context.queryClient),
    )
    if (!session?.session) {
      throw redirect({
        to: getAuthRoute(AUTH_ROUTES.signIn) as any,
        search: ((prev: any) => ({ ...prev, redirectTo: location.href })) as any,
      })
    }
    
    // PAID / EXPLORER tier gate (Explorer, Pro, Premium)
    const user = session.user as any
    const isPaid = user.tier === 'EXPLORER' || user.tier === 'PRO' || user.tier === 'PREMIUM'
    if (!isPaid) {
      throw redirect({
        to: '/dashboard' as any,
        search: ((prev: any) => ({ ...prev, upgrade_required: true })) as any,
      })
    }
    
    return { session, user }
  },
  head: ({ params }: any) => {
    const locale = params.locale
    const meta = getPageMeta('/ai-assistant', locale) || { title: 'AI Assistant', description: 'Your personal AI dining assistant' }
    return seo({
      ...meta,
      pathname: '/ai-assistant',
      locale,
    })
  },
  component: AiAssistantPage,
})
